/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreMetaDataDto
 */
export interface StoreMetaDataDto {
    /**
     * 
     */
    buCode?: string;
    /**
     * 
     */
    countryCode?: string;
    /**
     * Indicates if the cloud is the master for the store, i.e., that writes should happen to cloud databases
     */
    isCloudMaster?: boolean;
    /**
     * Indicates the kind of logistic system used in the store
     */
    logisticSystem?: StoreMetaDataDtoLogisticSystemEnum;
    /**
     * Local time zone information from CBD. Note that this is only populated on the store's DB shard.
     */
    addressTimeZone?: string;
    /**
     * Indicates whether the store is a small store, which has implications on certain parameters and calculations.
     */
    isSmallStore?: boolean;
}


/**
 * @export
 */
export const StoreMetaDataDtoLogisticSystemEnum = {
    Mhs: 'mhs',
    Fms: 'fms',
} as const;
export type StoreMetaDataDtoLogisticSystemEnum = typeof StoreMetaDataDtoLogisticSystemEnum[keyof typeof StoreMetaDataDtoLogisticSystemEnum];


/**
 * Check if a given object implements the StoreMetaDataDto interface.
 */
export function instanceOfStoreMetaDataDto(value: object): value is StoreMetaDataDto {
    return true;
}

export function StoreMetaDataDtoFromJSON(json: any): StoreMetaDataDto {
    return StoreMetaDataDtoFromJSONTyped(json, false);
}

export function StoreMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreMetaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'buCode': json['buCode'] == null ? undefined : json['buCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'isCloudMaster': json['isCloudMaster'] == null ? undefined : json['isCloudMaster'],
        'logisticSystem': json['logisticSystem'] == null ? undefined : json['logisticSystem'],
        'addressTimeZone': json['addressTimeZone'] == null ? undefined : json['addressTimeZone'],
        'isSmallStore': json['isSmallStore'] == null ? undefined : json['isSmallStore'],
    };
}

export function StoreMetaDataDtoToJSON(json: any): StoreMetaDataDto {
    return StoreMetaDataDtoToJSONTyped(json, false);
}

export function StoreMetaDataDtoToJSONTyped(value?: StoreMetaDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buCode': value['buCode'],
        'countryCode': value['countryCode'],
        'isCloudMaster': value['isCloudMaster'],
        'logisticSystem': value['logisticSystem'],
        'addressTimeZone': value['addressTimeZone'],
        'isSmallStore': value['isSmallStore'],
    };
}

